import { Earnings } from '@benzinga/calendar-manager';
import CalendarService from '../lib/services/CalendarService';

const fetchEarnings = (params = {}, pageSize = 1000): Promise<Earnings[]> => {
  const query = {
    ...params,
    pagesize: pageSize,
  };

  const Calendar = new CalendarService();

  return Calendar.getEarnings(query).then(({ data }: { data: { earnings: Earnings[] } }) => {
    if (data && data.earnings) {
      const { earnings } = data;

      earnings.sort((a: Earnings, b: Earnings) => {
        return parseInt(b.revenue_est, 10) - parseInt(a.revenue_est, 10);
      });

      return earnings || [];
    }
    return [];
  });
};

export { fetchEarnings };
